var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "warnings-list", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _vm.alertsList.length === 0
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-icon",
                    { attrs: { color: "grey lighten-1", size: "64" } },
                    [_vm._v("mdi-alert-circle-outline")]
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("No warnings to display"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.alertsList, function (alert, index) {
            return [
              _c(
                "v-alert",
                {
                  key: index,
                  staticClass: "mb-2 rounded-lg pl-2 pr-3 py-3",
                  attrs: {
                    prominent: "",
                    outlined: "",
                    color: "orange",
                    type: "error",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "grow" }, [
                        _c("div", [
                          _vm._v(
                            "Equipment: " + _vm._s(alert.locationId ?? "N/A")
                          ),
                        ]),
                        _c("div", [_vm._v(" " + _vm._s(alert.message) + " ")]),
                      ]),
                      _c("v-col", { staticClass: "shrink text-right" }, [
                        _c("div", { staticClass: "text-caption black--text" }, [
                          _vm._v(
                            "#" + _vm._s(_vm.alertsList.indexOf(alert) + 1)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }